import { render, staticRenderFns } from "./procedimento_especialidade.vue?vue&type=template&id=3490a70e"
import script from "./procedimento_especialidade.vue?vue&type=script&lang=js"
export * from "./procedimento_especialidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports